import { injectable } from 'tsyringe';
import { IOwTrackRSEventWrapper } from 'app-core/src/interfaces/ow-wrappers/ow-track-rs-event.interface';

// -------------------------------------------------------------
@injectable()
export class OWTrackRSWrapper implements IOwTrackRSEventWrapper {
  // -------------------------------------------------------------
  public trackRSEvent(name: string, extraData: any, overrides: any) {
    if (typeof overwolfInternal.trackRSEventV2 === 'undefined') {
      return overwolfInternal.trackRSEvent(name, extraData, overrides);
    }

    return overwolfInternal.trackRSEventV2(name, extraData, overrides);
  }
}
